import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { EMAIL_SUBSCRIPTION_ENTITY, PROMO_ENTITY, PromoState } from '../promo-state';

export type PromoReducers = PromoState;

export function getReducers(): ActionReducerMap<PromoReducers> {
  return {
    emailSubscription: StateUtils.loaderReducer(EMAIL_SUBSCRIPTION_ENTITY),
    promo: StateUtils.loaderReducer(PROMO_ENTITY),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<PromoReducers>> = new InjectionToken<
  ActionReducerMap<PromoReducers>
>('PromoReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
